import { createTheme } from "@mui/material/styles"
// import { makeStyles } from "@mui/styles";

export const appStyles = {
  color: {
    blue: '#0078a9'
  }
}

/* Older JSS CSS method that is now deprecated
export const useStyles = makeStyles((theme) => ({
    banner: {
        position: "relative",
        maxWidth: '100vw'
      },
      bannerTextBox: {
          position: "absolute",
          left: "12vw",
          top: "5rem",
          display: "flex",
          flexDirection: "column",
          maxWidth: "20rem",
          background: "#fff",
          borderRadius: "5px",
          padding: "2rem",
          lineHeight: "1.5",
          [theme.breakpoints.down("sm")]: {
              maxWidth: "16rem",
              top: "0",
              right: "0",
              bottom: "0",
              left: "0",
              margin: "2rem auto",
            },
        },
        bannerTextBoxHeader: {
            color: "#0078a9",
            fontWeight: "bold",
            fontSize: "1.3rem",
        },
        bannerTextBoxSubHeader: {
          margin: "1rem 0 0 0",
        },
      bannerTextBoxButton: {
        background: "#0078a9",
        color: "#fff",
        textTransform: "none",
        display: "flex",
        alignSelf: "end",
        marginTop: "1.5em",
        "&:hover": {
          background: "#006c98",
        },
      },
    infoIcon: {
      color: appStyles.color.blue,
      fontSize: '0.9rem',
      margin: '0 0.25rem'
    }
}));
*/ 

const theme = createTheme({

})


export default theme;